import React, { useEffect, useState } from "react";

const EVENT_END = new Date("2026-08-22T00:00:00+09:00");
const SHOW_MS = 5000;
const IMG = "/imid-2026-booth-21.jpg";
const LINK = "/research-highlights/imid-2026-booth-21.html";
const BOOK = "https://cal.com/yogeshgawale";

const T = {
  en: { cap: "Booth 21 - IMID 2026 - BEXCO, Busan - August 18 to 21",
        more: "For more information, see Research Highlights",
        book: "Book a meeting slot", view: "View details", visit: "Visit us at" },
  ko: { cap: "부스 21 - IMID 2026 - 부산 벡스코 - 8월 18일 ~ 21일",
        more: "자세한 내용은 리서치 하이라이트를 확인하세요",
        book: "미팅 예약하기", view: "자세히 보기", visit: "만나요" },
  zh: { cap: "展位 21 - IMID 2026 - 釜山 BEXCO - 8月18日至21日",
        more: "更多信息请查看研究亮点",
        book: "预约会面", view: "查看详情", visit: "欢迎莅临" },
  de: { cap: "Stand 21 - IMID 2026 - BEXCO, Busan - 18. bis 21. August",
        more: "Weitere Informationen finden Sie in den Research Highlights",
        book: "Termin buchen", view: "Details ansehen", visit: "Besuchen Sie uns" },
};

const CSS = "@keyframes lamkoFloat{0%{transform:translateY(0)}50%{transform:translateY(-14px)}100%{transform:translateY(0)}}" +
  "@keyframes lamkoGlow{0%{opacity:.45}50%{opacity:.9}100%{opacity:.45}}" +
  "@keyframes lamkoIn{0%{opacity:0;transform:scale(.86) translateY(26px)}100%{opacity:1;transform:scale(1) translateY(0)}}" +
  ".lamko-float{animation:lamkoFloat 4.5s ease-in-out infinite}" +
  ".lamko-in{animation:lamkoIn .65s cubic-bezier(.16,1,.3,1) both}" +
  ".lamko-glow{animation:lamkoGlow 3s ease-in-out infinite}" +
  ".lamko-eb-btn{transition:transform .18s ease,box-shadow .18s ease}" +
  ".lamko-eb-btn:hover{transform:translateY(-2px);box-shadow:0 10px 26px rgba(234,88,12,.45)}";

export const EventBanner = () => {
  const [phase, setPhase] = useState("idle");
  const [left, setLeft] = useState(SHOW_MS);

  useEffect(() => {
    /* HOME_ONLY: never interrupt deep links such as form pages */
    try { if ((window.location.pathname || "/") !== "/") return; } catch (e) {}
    if (new Date() >= EVENT_END) return;
    try { if (window.sessionStorage.getItem("lamko_imid26_seen")) return; } catch (e) {}
    let cancelled = false, tick = null, hideT = null, doneT = null;
    const started = Date.now();
    const poll = setInterval(() => {
      if (cancelled) return;
      const splash = document.querySelector('[data-testid="splash-skip"]');
      if (!splash || Date.now() - started > 6000) {
        clearInterval(poll);
        try { window.sessionStorage.setItem("lamko_imid26_seen", "1"); } catch (e) {}
        const t0 = Date.now();
        setPhase("in");
        tick = setInterval(() => setLeft(Math.max(0, SHOW_MS - (Date.now() - t0))), 80);
        hideT = setTimeout(() => setPhase("out"), SHOW_MS);
        doneT = setTimeout(() => setPhase("done"), SHOW_MS + 700);
      }
    }, 200);
    return () => { cancelled = true; clearInterval(poll); if (tick) clearInterval(tick); if (hideT) clearTimeout(hideT); if (doneT) clearTimeout(doneT); };
  }, []);

  if (phase === "idle" || phase === "done") return null;

  let lang = "en";
  try { lang = String(window.localStorage.getItem("i18nextLng") || navigator.language || "en").slice(0, 2); } catch (e) {}
  const c = T[lang] || T.en;
  const close = (e) => { if (e) e.stopPropagation(); setPhase("out"); setTimeout(() => setPhase("done"), 700); };
  const R = 15.9155, pct = left / SHOW_MS;

  return (
    <div onClick={close} style={{ position: "fixed", inset: 0, zIndex: 60, background: "radial-gradient(circle at 50% 45%, rgba(15,23,42,.93), rgba(2,6,23,.97))", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "18px", opacity: phase === "in" ? 1 : 0, transition: "opacity 650ms ease" }}>
      <style>{CSS}</style>
      <div className="lamko-in" style={{ width: "100%", maxWidth: 1080, textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
        <div className="lamko-float" style={{ position: "relative" }}>
          <div className="lamko-glow" style={{ position: "absolute", inset: "-14px", borderRadius: 22, background: "linear-gradient(90deg,#ea580c,#f59e0b,#38bdf8,#ea580c)", filter: "blur(22px)" }} />
          <a href={LINK} style={{ position: "relative", display: "block", textDecoration: "none" }}>
            <img src={IMG} alt="LUMORA at IMID 2026, Booth 21, BEXCO Busan, August 18 to 21, 2026" style={{ width: "100%", height: "auto", borderRadius: 14, display: "block", boxShadow: "0 26px 70px rgba(0,0,0,.6)" }} />
          </a>
        </div>
        <div style={{ marginTop: 20, color: "#fff", fontSize: 17, fontWeight: 800, letterSpacing: .3 }}>{c.cap}</div>
        <div style={{ marginTop: 6, color: "#cbd5e1", fontSize: 13 }}>{c.more}</div>
        <div style={{ marginTop: 18, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <a className="lamko-eb-btn" href={BOOK} target="_blank" rel="noopener noreferrer" style={{ background: "linear-gradient(90deg,#ea580c,#f59e0b)", color: "#fff", fontWeight: 700, padding: "13px 28px", borderRadius: 10, textDecoration: "none", fontSize: 15 }}>{c.book}</a>
          <a className="lamko-eb-btn" href={LINK} style={{ background: "rgba(255,255,255,.08)", color: "#fdba74", fontWeight: 600, padding: "13px 24px", borderRadius: 10, textDecoration: "none", fontSize: 15, border: "1px solid rgba(253,186,116,.55)" }}>{c.view}</a>
        </div>
      </div>
      <button type="button" onClick={close} aria-label="Close" style={{ position: "absolute", top: 20, right: 20, width: 46, height: 46, background: "rgba(255,255,255,.1)", border: "1px solid rgba(255,255,255,.35)", color: "#fff", borderRadius: "50%", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <svg viewBox="0 0 36 36" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", transform: "rotate(-90deg)" }}>
          <circle cx="18" cy="18" r={R} fill="none" stroke="rgba(255,255,255,.18)" strokeWidth="2" />
          <circle cx="18" cy="18" r={R} fill="none" stroke="#fdba74" strokeWidth="2" strokeDasharray={(100 * pct) + " 100"} strokeLinecap="round" />
        </svg>
        <span style={{ position: "relative", fontSize: 16, lineHeight: 1 }}>&#10005;</span>
      </button>
    </div>
  );
};

export default EventBanner;
